import { memo } from 'react';
import styles from './styles.module.scss';
import { Icon } from '../../gui/Icon';
import { humanNumber, roundTo } from '@game-libs/exc-libs';
import { useCurrencyStore } from '../../store/zustand/useCurrencyStore';

export const ResourcesList = memo(function ResourcesList({ isLarge = true }: { isLarge?: boolean }) {
  const gold = useCurrencyStore((state) => state.gold);

  return (
    <div className={`${styles.resourcesContainer} ${isLarge ? styles.large : styles.small}`}>
      <div className={styles.resource}>
        <Icon large={isLarge} iconId={isLarge ? 'coin_stack' : 'item_cost_gold'} />
        <div data-testid="gold-value">
          <div data-testid="gold-value">
            {import.meta.env.VITE_IS_PROD !== 'true' ? roundTo(gold, 2) : humanNumber(gold)}
          </div>
        </div>
      </div>
      {/* <div className={styles.foodDisplay}>
          <Icon large iconId={'food_resource'} />
          <div>{humanNumber(food)}</div>
        </div>
        <div className={styles.foodDisplay}>
          <Icon large iconId={'wood_resource'} />
          <div>{humanNumber(wood)}</div>
        </div>
        <div className={styles.foodDisplay}>
          <Icon large iconId={'ore_resource'} />
          <div>{humanNumber(ore)}</div>
        </div> */}
    </div>
  );
});
